import { THEME_MODEL } from "./model";
import isNil from "lodash/isNil.js";

export {
  isCSSFile,
  brighten,
  darken,
  palette,
  toFilter,
  getValue
} from "./utils.js";

export function Theme(values) {
  this.values = values || { ...THEME_MODEL };

  !values &&
    Object.entries(this.values).forEach(([key, value]) => {
      if (value.ref) this.values[key].defaultRef = value.ref;
    });

  this.load = (values) => {
    Object.entries(values).forEach(([key, obj]) => {
      if (!isNil(obj.value)) {
        this.values[key].value = obj.value;
        this.values[key].modified = true;
      } else if (obj.ref) {
        this.values[key].ref = obj.ref;
        this.values[key].modified = true;
      }
    });
  };

  this.setValue = (key, value) => {
    this.values[key].value = value;
    this.values[key].modified = true;
    trigger(key);
  };

  this.setRef = (key, value) => {
    this.values[key].ref = value;
    this.values[key].modified = true;
    trigger(key);
  };

  this.reset = (key, isGroup) => {
    if (isGroup) {
      Object.keys(this.values)
        .filter((k) => k.indexOf(key) === 0)
        .forEach((key) => {
          this.values[key].value = this.values[key].defaultValue;
          Reflect.deleteProperty(this.values[key], "modified");
        });
    } else {
      this.values[key].value = this.values[key].defaultValue;
      Reflect.deleteProperty(this.values[key], "modified");
    }
    trigger(key);
  };

  this.toJSON = () => {
    return Object.entries(this.values).reduce((memo, [key, obj]) => {
      if (obj.modified) {
        if (!isNil(obj.value)) {
          memo[key] = { value: obj.value };
        } else if (obj.ref) {
          memo[key] = { ref: obj.ref };
        }
      }
      return memo;
    }, {});
  };

  function keyToCSS(key) {
    return `--kf-${key.toLowerCase().split(".").join("-")}`;
  }

  const getValue = (key, autoPriority) => {
    const obj = this.values[key];
    if (!obj) return;
    if (!isNil(obj.value)) {
      return obj.value;
    }
    if (!autoPriority && obj.ref) {
      return getValue(obj.ref);
    }
    if (obj.valueFunc) {
      return obj.valueFunc(this.values);
    }
    if (autoPriority && obj.ref) {
      return getValue(obj.ref);
    }
    return obj.defaultValue;
  };

  this.getValue = getValue;

  this.toCSS = () => {
    let css = "";
    Object.entries(this.values).forEach(([key, obj]) => {
      if (obj.modified) {
        try {
          if (key === "FontFamily.Name") {
            css += `--kf-font-family: ${getValue(key)};`;
          } else {
            css += `${keyToCSS(key)}: ${getValue(key)};\r\n`;
            obj.referredIn?.forEach((key) => {
              css += `${keyToCSS(key)}: ${getValue(key, true)};\r\n`;
            });
          }
        } catch (ex) {
          console.log("EX", ex);
        }
      }
    });
    return css;
  };

  this.toCSSObject = () => {
    let css = {};
    Object.entries(this.values).forEach(([key, obj]) => {
      if (obj.modified) {
        try {
          if (key === "FontFamily.Name") {
            css["--kf-font-family"] = getValue(key);
          } else if (key.endsWith(".Shadow")) {
            console.log("GOT SHADOW", key);
            const shadowMap = {
              none: "none",
              "shadow-100": "var(--kf-shadow-100-pos)",
              "shadow-200": "var(--kf-shadow-200-pos)",
              "shadow-300": "var(--kf-shadow-300-pos)",
              "shadow-500": "var(--kf-shadow-500-pos)"
            };
            const value = getValue(key);

            const type = value.split("|")[0];
            const color = value.split("|")[1];
            console.log("VALE ", value, type, color);
            if (color) {
              css[keyToCSS(key)] = `${shadowMap[type]} var(${keyToCSS(color)})`;
            } else {
              css[keyToCSS(key)] = shadowMap[type];
            }
          } else {
            css[keyToCSS(key)] = getValue(key);
            obj.referredIn?.forEach((key) => {
              css[keyToCSS(key)] = getValue(key, true);
            });
          }
        } catch (ex) {
          console.log("EX", ex);
          throw ex;
        }
      }
    });
    return css;
  };

  this.toAllValues = () => {
    const json = {};
    Object.keys(this.values).forEach((key) => {
      json[key] = getValue(key);
    });
    return json;
  };

  let changeHandlers = [];

  this.onChange = (callback) => {
    changeHandlers.push(callback);
  };

  function trigger(data) {
    changeHandlers.forEach((callback) => {
      callback(data);
    });
  }
}

window.Theme = Theme;
